import { produce } from 'immer';

import { SearchInternalProducts } from '../../../actions/products/internal/searchInternalProducts';
import { ProductsState } from '../../../typings/products';

export function searchInternalProducts(state: ProductsState, action: SearchInternalProducts): ProductsState {
    return produce(state, draft => {
        const text = action.text.toUpperCase();

        draft.filtered = draft.products.filter(({ productName }) => {
            return productName.toUpperCase().includes(text);
        });

        draft.isFiltered = text.length > 0;
    });
}
